import AuthService from '../../utilities/services/auth.service'

import { ModalProvider } from '../../providers/ModalProvider/ModalProvider'

import { FlexPackDeferredRevenueWrapper } from '../../components'

export default function FlexPackDeferredRevenuePage() {
  const organization = AuthService.getOrg()[0]

  return (
    <ModalProvider>
      <FlexPackDeferredRevenueWrapper organization={organization} />
    </ModalProvider>
  )
}
